import { IsDevEnv, IS_SSR, Theme } from '@/app'
import { View, Text } from '@/components'
import { useIsFocusedFeedItem } from '../feedScroll'
import { RenderItemProps } from './types'

const spacingTop = Theme.spacing.value(1)
const spacingBottom = Theme.spacing.value(1)
const spacing = spacingTop + spacingBottom
const aspectRatio = 900 / 1600
const HEIGHT = `calc(100dvh - ${spacing + Theme.values.headerHeight}px)`
const WIDTH = `calc(${HEIGHT} * ${aspectRatio})`
const HEIGHT_WITHOUT_SPACING = `calc(100dvh - ${Theme.values.headerHeight}px)`

export const FeedDimensions = {
  WIDTH: WIDTH,
  HEIGHT: HEIGHT,
  WIDTH_WITHOUT_SPACING: `100vw`,
  HEIGHT_WITHOUT_SPACING,
  aspectRatio,
  spacingTop,
  spacingBottom,
  mobileBreakpoint: 'small' as any,
  getHeightNumber(withSpacing = false) {
    if (IS_SSR) return 0
    return window.innerHeight - (Theme.values.headerHeight + (withSpacing ? spacing : 0))
  },
}

export const DEBUG_FEED_ITEMS = IsDevEnv

const colorMap = {
  video: '#4effbe',
  text: '#00ff00',
  image: '#f009',
  lesson: '#0000ff',
  prompt: '#ffff00',
  review: '#ff00ff',
  review_question: '#00ffff',
  story: '#ff9900',
  image_answer: '#f009',
  text_answer: '#00ff00',
  video_answer: '#4effbe',
  hurdle: '#000',
  game: '#9900ff',
  profile_prompt: '#ff3366',
}

export const DebugItem = (props: RenderItemProps) => {
  if (!DEBUG_FEED_ITEMS) return null

  const { item, index } = props

  const isFocused = useIsFocusedFeedItem(index)

  const promptKey = props?.item?.profile_prompt?.key

  return (
    <View
      onClick={() => {
        console.log(JSON.stringify(item, null, 2))
        alert(JSON.stringify(item, null, 2))
      }}
      variants={['column', 'absolute']}
      style={{
        top: 8,
        [!!promptKey ? 'right' : 'left']: 8,
        background: colorMap[item?.type],
        zIndex: 30,
        cursor: 'pointer',
        borderRadius: 16,
        padding: 8,
        paddingLeft: 12,
        paddingRight: 12,
      }}
    >
      <Text text={'ID - ' + item?.id} />
      <Text text={'Type - ' + item?.type} />
      {!!promptKey ? <Text text={'Key - ' + promptKey} /> : null}
      <Text text={'Index - ' + index} />
      <Text text={'Focused - ' + isFocused} />
    </View>
  )
}
